/**
 * Machine-readable error codes for the appointments API.
 */ /** HTTP 409: `expectedStatus` no longer matches the stored status. */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get APPOINTMENT_INVALID_TRANSITION () {
        return APPOINTMENT_INVALID_TRANSITION;
    },
    get APPOINTMENT_NOT_RESCHEDULABLE () {
        return APPOINTMENT_NOT_RESCHEDULABLE;
    },
    get APPOINTMENT_STATUS_CONFLICT () {
        return APPOINTMENT_STATUS_CONFLICT;
    },
    get APPOINTMENT_UPDATE_CONFLICT () {
        return APPOINTMENT_UPDATE_CONFLICT;
    }
});
const APPOINTMENT_STATUS_CONFLICT = 'APPOINTMENT_STATUS_CONFLICT';
const APPOINTMENT_INVALID_TRANSITION = 'APPOINTMENT_INVALID_TRANSITION';
const APPOINTMENT_NOT_RESCHEDULABLE = 'APPOINTMENT_NOT_RESCHEDULABLE';
const APPOINTMENT_UPDATE_CONFLICT = 'APPOINTMENT_UPDATE_CONFLICT';
